import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './widget-visibility-toggle.scss';

/**
 * Widget-relative visibility toggle that appears when drag mode is enabled
 */
const WidgetVisibilityToggle = ({ widgetName, isVisible, onToggle }) => {
  return (
    <button
      className="widget-visibility-toggle"
      onClick={(e) => {
        e.stopPropagation();
        onToggle(!isVisible);
      }}
      aria-label={`${isVisible ? 'Hide' : 'Show'} ${widgetName}`}
      title={`${isVisible ? 'Hide' : 'Show'} ${widgetName}`}
    >
      {
        isVisible ?
          <FontAwesomeIcon icon={['fa', 'eye']} /> : <FontAwesomeIcon icon={['fa', 'eye-slash']} />
      }
    </button>
  );
};

export default WidgetVisibilityToggle;
